import {
  useMerchantDomainKnowledge,
  useMerchantRiskCatalog,
  useMerchantRisksList,
  useSaveSafetyConfig,
} from "@/api/merchant-risks";
import { SAFETY_POLICY_LABELS, useSafetyPolicies } from "@/api/safety-policies";
import { type RiskConfigFocus, RiskConfigModal } from "@/components/safety-config/RiskConfigModal";
import { success } from "@/providers/ToastProvider";

type ConfigureSafetyModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  focus?: RiskConfigFocus;
};

export const ConfigureSafetyModal = ({ open, onOpenChange, focus }: ConfigureSafetyModalProps) => {
  const { data: catalog } = useMerchantRiskCatalog();
  const { data: merchantRisksList } = useMerchantRisksList();
  const { data: safetyPolicies } = useSafetyPolicies();
  const { data: domainKnowledge } = useMerchantDomainKnowledge();
  const { mutate: saveConfig, isPending } = useSaveSafetyConfig();

  const policyOptions = (safetyPolicies ?? []).map((p) => ({
    id: p.id,
    label: SAFETY_POLICY_LABELS[p.type] ?? p.type,
    type: p.type,
  }));

  return (
    <RiskConfigModal
      open={open}
      onOpenChange={onOpenChange}
      title="Configure Risks"
      catalog={catalog}
      savedRisks={merchantRisksList}
      policies={policyOptions}
      savedDomainKnowledge={domainKnowledge}
      focus={focus}
      isSaving={isPending}
      onSave={(draft) =>
        saveConfig(draft, {
          onSuccess: () => {
            success("Configuration saved");
            onOpenChange(false);
          },
        })
      }
    />
  );
};
